var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBtnYt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "btn_yt",
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.404,
    height: 19.351,
    viewBox: "0 0 25.404 19.351",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_1262",
    "data-name": "\\u30D1\\u30B9 1262",
    d: "M23.95,62.876C22.649,61.825,18.058,61,12.7,61s-9.947.825-11.248,1.876C.257,63.841,0,68.2,0,70.675s.257,6.835,1.454,7.8c1.3,1.051,5.892,1.876,11.248,1.876s9.947-.825,11.248-1.876c1.2-.964,1.454-5.325,1.454-7.8S25.147,63.841,23.95,62.876Zm-7.437,7.919-5.9,3.52a.139.139,0,0,1-.21-.119V67.156a.139.139,0,0,1,.21-.119l5.9,3.52a.138.138,0,0,1,.067.119A.14.14,0,0,1,16.513,70.795Z",
    transform: "translate(0 -61)",
    fill: "#111"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnYt);
export default __webpack_public_path__ + "static/media/btn_yt.4e782167d95195e2e6bf4dd6211d6993.svg";
export { ForwardRef as ReactComponent };